/* eslint-disable */
import Swiper from 'swiper/js/swiper';

export default {
  init() {
    // JavaScript to be fired on the home page
    setTimeout(function() {
      let slider = new Swiper('#intro .swiper-container', {
        direction: 'horizontal',
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 28,
        threshold: 30,

        navigation: {
          nextEl: '.next',
          prevEl: '.prev',
        },
      })

      let sliderheader = new Swiper('#header .swiper-container', {
        autoplay: true,
        slidesPerView: 1,
        direction: 'horizontal',
        loop: true,
      })

      let swiperActu = new Swiper('#actu .swiper-container', {
        direction: 'horizontal',
        loop: false,
        slidesPerView: 1.1,
        spaceBetween: 28,
        breakpoints: {
          768: {
            slidesPerView: 2.1,
          },
          992: {
            slidesPerView: 3.1,
          },
          1200: {
            slidesPerView: 4.1,
          }
        },

        navigation: {
          nextEl: '.next',
          prevEl: '.prev',
        }
      });
    }, 200);
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js